import { FC, useCallback } from "react";
import { useAppDispatch } from "@/store/hooks";
import { getResourceExplorerDataThunk } from "@/store/resource-explorer/thunks/widgets/getResourceExplorerDataThunk";
import { ChartSeriesSelect } from "@/storybook/c8r-highcharts/common/components/ChartSeriesSelect";
import { updateBillingExplorerChartSettingsThunk } from "@/store/resource-explorer/thunks/resource-explorer/updateBillingExplorerChartSettingsThunk";

interface BillingExplorerChartSeriesSelectProps {
  series: number;
}

export const BillingExplorerChartSeriesSelect: FC<
  BillingExplorerChartSeriesSelectProps
> = ({ series }) => {
  const dispatch = useAppDispatch();

  const changeHandler = useCallback(
    (series: number) => {
      dispatch(updateBillingExplorerChartSettingsThunk({ series }));
      dispatch(getResourceExplorerDataThunk());
    },
    [dispatch],
  );

  return <ChartSeriesSelect series={series} onSeriesChange={changeHandler} />;
};
